import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SharedStateService {
  // Define a shared signal with an initial value
  sharedValue = signal<string>('');

  // Method to update the signal
  updateValue(newValue: string) {
    this.sharedValue.set(newValue);
  }
}
